<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @import './assets/css/main.css';

</style>



// WEBPACK FOOTER //
// src/App.vue